import { createSelector } from 'reselect';

import { Goal } from 'types';


const sortGoals = (input: Goal[]) => input
    .sort((g1, g2) => {
        let g1Value = g1.end_date ? new Date(g1.end_date).getTime() : Number.POSITIVE_INFINITY;
        let g2Value = g2.end_date ? new Date(g2.end_date).getTime() : Number.POSITIVE_INFINITY;

        if (g1.progress?.completed >= g1.progress?.total) {
            g1Value += 10000000000000;
        }
        if (g2.progress?.completed >= g2.progress?.total) {
            g2Value += 10000000000000;
        }

        if (g1Value > g2Value) return 1;
        if (g1Value < g2Value) return -1;

        const g1Name = (g1.name && g1.name.toLowerCase());
        const g2Name = (g2.name && g2.name.toLowerCase());

        if (g1Name > g2Name) return 1;
        if (g1Name < g2Name) return -1;

        if (g1.id > g2.id) return 1;
        if (g1.id < g2.id) return -1;

        return 0;
    });


const getGoal = (goals: Goal[], goalId: string) => goals.find(goal => goal.id === goalId);
export const makeGetGoal = () => createSelector(getGoal, goals => goals);

const getGoals = (goals: Goal[]) => sortGoals(goals
    .filter(goal => goal && !goal.removed && !goal.loading));
export const makeGetGoals = () => createSelector(getGoals, goals => goals);

const getGoalsBySourceType = (goals: Goal[], sourceType: Goal['source']['type']) => sortGoals(goals
    .filter(goal => goal && !goal.removed && !goal.loading && goal.source?.type === sourceType));
export const makeGetGoalsBySourceType = () => createSelector(getGoalsBySourceType, goals => goals);
